if (document.querySelectorAll('.offers-tabbed-component-tabs > button.nav-link').length > 1) {

    function isMobile() {
        return window.innerWidth <= 991;
    }

    var tabCarousel;

    function startCarousel() {
        if (tabCarousel) {
            clearInterval(tabCarousel);
        }

        tabCarousel = setInterval(function () {
            var tabs = document.querySelectorAll('.offers-tabbed-component-tabs > button');
            var activeTab = document.querySelector('.offers-tabbed-component-tabs > button.active');
            var nextTab = activeTab ? activeTab.nextElementSibling : tabs[0];

            if (!nextTab) {
                nextTab = tabs[0];
            }

            var nextActiveElId = nextTab.getAttribute('data-bs-target').replace("#", "");

            var nextActiveEl = document.getElementById(nextActiveElId);

            var offerPanels = document.querySelectorAll('.offers-tabbed-component .tab-pane');
            offerPanels.forEach(function (panel) {
                panel.classList.remove('active');
                panel.classList.remove('show');
            });

            activateTab(nextTab);

            nextActiveEl.classList.add('show');
            nextActiveEl.classList.add('active');

            //nextTab.click();

        }, 5000);
    }

    function activateTab(tab) {
        var tabs = document.querySelectorAll('.offers-tabbed-component-tabs > button');

        tabs.forEach(function (button) {
            button.classList.remove('active');
        });
        tab.classList.add('active');

        startCarousel(); // Reset the interval each time the active class changes
    }

    if (!isMobile()) {

        document.querySelectorAll('.offers-tabbed-component-tabs > button').forEach(function (button) {
            button.addEventListener('click', function () {
                activateTab(button);
            });
        });

        // Initialize the first tab as active
        var initialTab = document.querySelector('.offers-tabbed-component-tabs > button');
        if (initialTab) {
            activateTab(initialTab);
        }
        // Start the carousel for the first time
        startCarousel();
    }
}